import { header } from "./modules/header";
import { triggerModal, openResserModal } from "./modules/modal";
import { initLabel } from "./modules/floatlabel";
import { handleFormSubmit } from './modules/form';
import {initSmoothScroll} from "./modules/smoothscroll";
import { ajaxMainFilter } from "./modules/ajaxFilter";
import {initAnim} from "./modules/animations";
import FormDatePicker from "./modules/FormDatePicker";

const preloader = document.querySelector('.preloader');

document.addEventListener("DOMContentLoaded", function() {
  header().init()
  initLabel()
  handleFormSubmit().init();
  initSmoothScroll().init();
  openResserModal();
  new FormDatePicker();
})

window.onload = () => {
  if(preloader) {
    setTimeout(() => { 
      preloader.classList.add('hide');
      initAnim().init();
     }, 2800);
    setTimeout(() => { 
      preloader.remove();
      document.querySelector('.header__nav-main')?.classList.add('show');
    }, 3100);
    setTimeout(() => { 
      triggerModal();
    }, 4000);
  } else {
    initAnim().init();
    document.querySelector('.header__nav-main')?.classList.add('show');
    setTimeout(() => {
      triggerModal();
    }, 1200);
  }

  const eventFilters = document.querySelectorAll('.sk-acc-filter.events-filter');
  eventFilters.length > 0 && ajaxMainFilter(eventFilters, 'event');

  const newsFilters = document.querySelectorAll('.sk-acc-filter.news-filter');
  newsFilters.length > 0 &&  ajaxMainFilter(newsFilters , 'post');

  const memberEventsfilters = document.querySelectorAll('.sk-acc-filter.member-events-filter');
  memberEventsfilters.length > 0 && ajaxMainFilter(memberEventsfilters, 'event');

  const searchInputs = document.querySelectorAll('.sk-acc-filter__search');
  searchInputs.length && searchInputs.forEach((input) => input.addEventListener('keydown', (e) => (e.key === 'Enter') && e.preventDefault()));
};
